 <form [formGroup]="formGroup" id="amount-insured-form">
   <div class="d-flex flex-column">
     <div class="field-container">
       <h3> {{'createProposal.sumsInsured'|translate}}</h3>
     </div>
     <div class="d-flex flex-column">

        <app-input-field *ngIf="isHousingInsuranceLob"
                         class="field-container"
                         [control]="formGroup.controls.insuredSumType"
                         [label]="'createProposal.housingInsuranceSumType' | translate"
                         [showInfo]="true"
                         [header]="''"
                         [mainContent]="'infoIcon.unitModel.content' | translate">
         <mat-select formControlName="insuredSumType" class="input">
           <mat-option *ngFor="let opt of QuestionOptions.housingInsuranceSumTypes" [value]="opt">
             {{'createProposal.housingInsuranceSumTypeOptions.' + opt | translate}}
           </mat-option>
         </mat-select>
        </app-input-field>

        <div *ngIf="isHousingInsuranceLob" class="field-container">
          <button type="button" class="skendata-button" style="float: none; margin-left: 0;" (click)="scrollToSkendata.emit()">
            <img src="assets/img/skendata/skendata_logo_stripes.png" alt="skendata logo" style="height: 15px; width: auto;">
            {{'createProposal.skenData.scrollLink' | translate}}
          </button>
        </div>

        <div class="too-long-label">
         <ng-container *ngIf="isHousingInsuranceLob && formGroup.value.insuredSumType; else defaultInsuredLabel">
           {{'createProposal.housingInsuranceSumTypeOptions.' + formGroup.value.insuredSumType | translate}}*
         </ng-container>
         <ng-template #defaultInsuredLabel>
           {{'createProposal.insuredAmount'|translate}}*
         </ng-template>
       </div>
       <div class="d-flex field-container">
         <app-input-field class="w-100"
                          [control]="formGroup.controls.insuredAmount">
            <input name="insuredAmount"
                   appNumberFormat
                   formControlName="insuredAmount"
                   [class]="isValues1914Selected ? 'input' : 'left-rounded input'">
         </app-input-field>
          <app-input-field *ngIf="!isValues1914Selected" [control]="formGroup.controls.currency">
            <mat-select formControlName="currency"
                        class="right-rounded input currency"
                        [value]="formGroup.controls.currency" #singleSelect>
              <mat-option>
                <ngx-mat-select-search [formControl]="filterCtrlCurrency" ngDefaultControl></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of filteredOptionsCurrency |async" [value]="option">
                {{option}}
              </mat-option>
            </mat-select>
          </app-input-field>
        </div>
        <div
          *ngIf="formGroup.value.insuredAmount > 0"
          class="insuredAmountSubtitle">{{this.formGroup.value.insuredAmount | numberFormat | async}} {{isValues1914Selected ? '' : currencySymbol()}}</div>
       <app-input-field class="field-container"
                        [control]="formGroup.controls.amountDescription"
                        [label]="'createProposal.amountDescription'|translate">
               <textarea name="amountDescription"
                         cdkTextareaAutosize
                         [cdkAutosizeMinRows]="4"
                         formControlName="amountDescription"
                         class="input input-text-area"
                         placeholder="{{'createProposal.amountPlaceholder' | translate}}"></textarea>
       </app-input-field>
       <div class="d-flex field-container">
         <app-input-field class="w-100"
                          [control]="formGroup.controls.annualSalesAmount"
                          [label]="'createProposal.annualSalesAmount'|translate">
           <input name="annualSalesAmount"
                  appNumberFormat
                  formControlName="annualSalesAmount"
                  class="left-rounded input">
         </app-input-field>
         <app-input-field [control]="formGroup.controls.currency">
           <mat-select formControlName="currency"
                       class="right-rounded input currency"
                       [value]="formGroup.controls.currency" #singleSelect>
             <mat-option>
               <ngx-mat-select-search [formControl]="filterCtrlCurrency" ngDefaultControl></ngx-mat-select-search>
             </mat-option>
             <mat-option *ngFor="let option of filteredOptionsCurrency |async" [value]="option">
               {{option}}
             </mat-option>
           </mat-select>
         </app-input-field>
       </div>
       <div
         *ngIf="formGroup.value.annualSalesAmount > 0"
         class="insuredAmountSubtitle">{{this.formGroup.value.annualSalesAmount | numberFormat | async}} {{currencySymbol()}}</div>
       <app-input-field class="field-container"
                        [control]="formGroup.controls.annualSalesDescription"
                        [label]="'createProposal.annualSalesDescription'|translate">
               <textarea name="annualSalesDescription"
                         cdkTextareaAutosize
                         [cdkAutosizeMinRows]="4"
                         formControlName="annualSalesDescription"
                         class="input input-text-area"
                         placeholder="{{'createProposal.annualSalesPlaceholder' | translate}}"></textarea>
       </app-input-field>

     </div>

   </div>
 </form>
